import axios from "axios";

export const enviarMensajesMas = async (entidad) => {

    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/5da52b6e-7cdd-45ed-827c-e63e9696ef78', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/5da52b6e-7cdd-45ed-827c-e63e9696ef78',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
            return true
        })
        .catch((error) => {
            console.log(error);
            return false
        });

}